import { intersection } from '../intersection';
import { doesArrayContainTheGivenObject } from '../doesArrayContainTheGivenObject/doesArrayContainTheGivenObject';
/**
 * Function to find the intersection result between two array with a given comparator
 *
 * @param {Array<any>} collection
 * @param {Array<any>} comparsion
 * @param {Function} [comparator]
 *
 * @example
 * intersecionWith([{x: 1, y: 2}, {x: 2, y: 3}], [{x: 2, y: 3}, {x: 4, y: 5}], (arrVal, otherVal) => arrVal.x === otherVal.x)
 * // return [{x: 2, y: 3}]
 * @example
 * intersectionWith([1, 2, 3], [3, 4, 5], undefined);
 * // return [3]
 *
 * @return {*}  {Array<any>}
 */
export var intersectionWith = function (collection, comparsion, comparator) {
    if (!comparator || typeof comparator !== 'function')
        return intersection(collection, comparsion);
    return collection.reduce(function (acc, value) {
        comparsion.forEach(function (otherVal) {
            if (comparator(value, otherVal) && !doesArrayContainTheGivenObject(value, acc)) {
                acc.push(value);
            }
        });
        return acc;
    }, []);
};
//# sourceMappingURL=intersectionWith.js.map